<template>
  <div class="register">
    <public-header></public-header>
    <register-type></register-type>
    <public-footer></public-footer>
    <back-top></back-top>
  </div>
</template>
<script>
import PublicHeader from '@/components/PublicHeader'
import PublicFooter from '@/components/PublicFooter'
import BackTop from '@/components/BackTop'
import RegisterType from './components/RegisterType'
export default {
  name: 'Register',
  components: {
    PublicHeader,
    PublicFooter,
    BackTop,
    RegisterType
  },
  methods: {
    checkLogin () {
      if (!this.$store.state.code) {
        this.$router.push('/login')
      }
    }
  },
  created() {
    this.checkLogin()
  }
}
</script>
<style scoped>
  .register{background-image: linear-gradient(45deg, #fe9539, #fed564);}
</style>
